import { ShortAddress } from "./address.ts"

export async function* requestDistanceMatrix(clusters: ShortAddress[][])
{
	for (const cluster of clusters)
	{
		const coords = cluster.map(x => x.latlon)

		let url = URL(coords)

		let res = await fetch(url)
		let json = await res.json()

		yield json
	}
}

let URL = (coords: [lat: number, lon: number][]) =>
{
	let allCoords = coords.map(([lat, lon]) => `${lon.toFixed(6)},${lat.toFixed(6)}`).join(";")

	return `https://router.project-osrm.org/table/v1/driving/${allCoords}?annotations=distance`
}